//Imports
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
//Imports Contexts
import { AppContext } from "../../../contexts/AppContext";
import { AuthContext } from "../../../contexts/AuthContext";
//Imports Icons
import ContainerSearch from "./ContainerSearch";
// import CumpliancePME from "../../../shared/CumpliancePME";
import addPME from '../../../assets/icons/pmeWhite.svg';
import establishmentLogo from '../../../assets/icons/establishmentHover.svg';
import visible from '../../../assets/icons/visible.svg';
import addRound from '../../../assets/icons/addRound.svg';
//Imports CSS
import './addPme.css';

function AddPME() {
    const { dataProjects, establishmentList, pmeList, dataSearch, setDataSearch } = useContext(AppContext);
    const { userData } = useContext(AuthContext);
    const [filteredPMEs, setFilteredPMEs] = useState([]);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const navigate = useNavigate();
    

    useEffect(() => {
        if (userData) {
            if (userData && userData.dimension === 'Establecimiento') {
                const filteredPMEs = pmeList.filter(pme => pme.establishmentId === userData.establishmentId);
                setFilteredPMEs(filteredPMEs.sort((a, b) => a.yearPME - b.yearPME));
                setIsButtonDisabled(false);
            }
            else if (dataSearch.establishment?.id) {
                const filteredPMEs = pmeList.filter(pme => pme.establishmentId === dataSearch.establishment.id);
                setFilteredPMEs(filteredPMEs.sort((a, b) => a.yearPME - b.yearPME));
                setIsButtonDisabled(false);

            } else {
                setFilteredPMEs([]);
                setIsButtonDisabled(true);
            }
        }
    }, [userData, dataSearch, pmeList]);

    const handleSelect = (selectedOption, { name }) => {
        const value = selectedOption ? selectedOption.value : null;
        const id = selectedOption ? selectedOption.id : null;
        setDataSearch(prevState => ({
            ...prevState,
            [name]: name === 'holder' || name === 'establishment'
                ? { value, id }
                : value,
            ...(name === 'region' && { commune: null, holder: { value: null, id: null }, establishment: null }),
            ...(name === 'commune' && { holder: { value: null, id: null }, establishment: null }),
            ...(name === 'holder' && { establishment: null })
        }));
    };

    const handleButtonClick = () => {
        if (dataSearch.establishment.id) {
            const filteredPMEs = pmeList.filter(pme => pme.establishmentId === dataSearch.establishment.id);
            setFilteredPMEs(filteredPMEs.sort((a, b) => a.yearPME - b.yearPME));
            setIsButtonDisabled(false);
        }
    };

    const handleViewPME = (pme) => {
        const navigationState =
            userData && userData.dimension === 'Establecimiento'
                ? {
                    pme,
                    viewMode: true,
                    establishmentId: userData.establishmentId,
                    dataSearch
                }
                : {
                    pme,
                    viewMode: true,
                    establishmentId: dataSearch.establishment?.id,
                    dataSearch
                };

        navigate(`${pme.id}`, { state: navigationState });
    };

    return (
        <section className='container-add-pme flex'>
            <ContainerSearch
                dataSearch={dataSearch}
                setDataSearch={setDataSearch}
                handleSelect={handleSelect}
                handleButtonClick={handleButtonClick}
                dataProjects={dataProjects}
                establishmentList={establishmentList}
            />
            <article className='container-result-pme flex'>
                {filteredPMEs.length > 0 ? (
                    filteredPMEs.map(pme => (
                        <article className='box-pme flex' key={pme.id}>
                            <img src={establishmentLogo} className='icon-logo' alt='Logo establecimiento' />
                            <p className='bold'>Plan de Mejoramiento Educativo</p>
                            <h3>{pme.yearPME}</h3>
                            <aside className='result-pme flex'>
                                <div className='view-pme flex' onClick={() => handleViewPME(pme)}>
                                    <img src={visible} className='icon' alt='Icono para ver PME' />
                                </div>
                                {/* <CumpliancePME percentage='60' /> */}
                            </aside>
                        </article>
                    ))
                ) : (
                    <p>No existen PMEs</p>
                )}
                {!isButtonDisabled && (
                    <Link
                        className='add-pme-button flex'
                        to={`add`}
                        state={
                            (userData && userData.dimension === 'Establecimiento')
                                ? { establishmentId: userData.establishmentId, dataSearch }
                                : { establishmentId: dataSearch.establishment?.id, dataSearch }
                        }
                    >
                        <img src={addRound} className='icon' alt='Icono para agregar nuevo PME' />
                    </Link>
                )}

            </article>
            <Link
                className='container-button flex'
                to={`${isButtonDisabled ? '#' : 'add'}`}
                state={
                    (userData && userData.dimension === 'Establecimiento')
                        ? { establishmentId: userData.establishmentId, dataSearch }
                        : { establishmentId: dataSearch.establishment?.id, dataSearch }
                }
                onClick={(e) => isButtonDisabled && e.preventDefault()}
            >
                <button type='button' className={`box-button flex ${isButtonDisabled && 'disabled'}`} disabled={isButtonDisabled} >
                    <img src={addPME} className='icon' alt='Icono para agregar PME' />
                    <p>Agregar Nuevo PME</p>
                </button>
            </Link>
        </section>
    )
};

export default AddPME;